<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      show-save-button
      unit="装箱规格"
      edit-title
      id-key="PackingSpeciId"
      :data="data"
      :line-form="true"
      form-label-width="110px"
      :form-rules="rules"
      :save-func="api.save"
      @opened="onOpened"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="规格编码" prop="SpeciNo">
          <el-input v-model="data.SpeciNo" placeholder="请输入规格编码" />
        </el-form-item>
        <el-form-item label="规格名称" prop="SpeciName">
          <el-input v-model="data.SpeciName" placeholder="请输入规格名称" />
        </el-form-item>

       <el-form-item label="单位" prop="Unit">
          <el-input v-model="data.Unit" placeholder="请输入单位" />
        </el-form-item>
        <el-form-item label="装箱数量" prop="PackingNumber">
          <el-input type="number" v-int v-model="data.PackingNumber" placeholder="请输入装箱数量" />
        </el-form-item>
          <el-form-item label="备注" prop="Remark">
          <el-input v-model="data.Remark" placeholder="请输入备注" />
        </el-form-item>

        <el-form-item label="序号" prop="Sn">
          <el-input type="number" v-int v-model="data.Sn" style="width: 100px"></el-input>
          <!-- <el-input-number v-model.number="data.Sn" :min="0" step-strictly style="width: 100px" ></el-input-number> -->
          <span class="t-tips">*值越小排得越前</span>
        </el-form-item>
        <el-form-item label="状态" prop="Status" >
          <el-radio-group v-model="data.Status" class="detail-span">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        PackingSpeciId: 0,
        SpeciNo: "",
        SpeciName: "",
        Unit: "个",
        Remark: "",
        PackingNumber:null,
        Status: 1,
        Sn:null,
      },
      formApi: require("@/api/sy/formSetting").default,
      api: require("@/api/ba/packingspeci").default,
      // trendData: iForm.Data,
      showList: [],
      rules: {
        SpeciNo: [{ required: true, message: "请输入编码" }],
        SpeciName: [{ required: true, message: "请输入名称" }],
        Unit: [{ required: true, message: "请输入单位" }],
        PackingNumber: [{ required: true, message: "请输入装箱数量" }],
        Sn: [{ required: true, message: "请输入序号" }],
      },
    };
  },
  methods: {
    // 打开时获取显示显示列表
    onOpened() {
      let modeName = this.urlHash ? this.urlHash.split("/").join(""): location.hash.split("/").slice(1).join("");
      this.formApi.list({ type: modeName }).then((res) => {
        this.showList = res.Data?.map((x) => x.ShowField);
      });
           
    },
    //判断显示
    iShow(data) {
      if (this.showList == null || this.showList.length === 0) return true;
      return this.showList.indexOf(data) !== -1 ? true : false;
    },
    onCreateOpened() {
      this.api.getMaxSn().then((res) => {
        this.data.Sn = res;
      });
    },
    onEditOpened(data) {},

    onClosed() {
      this.showList = [];
    },
  },
};
</script>